import { createSlice } from '@reduxjs/toolkit';

export const vanDataSlice = createSlice({
  name: 'vanData',
  initialState: {
    vanData: {},
  },
  reducers: {
    addVanData: (state, action) => {
      state.vanData = action.payload
    },
  },
});

export const { addVanData } = vanDataSlice.actions;

export const selectVanData = state => state.vanData.vanData;

export default vanDataSlice.reducer;
